import { render, staticRenderFns } from "./AdminMessageListCard.vue?vue&type=template&id=78eb5104&scoped=true"
import script from "./AdminMessageListCard.vue?vue&type=script&lang=js"
export * from "./AdminMessageListCard.vue?vue&type=script&lang=js"
import style0 from "./AdminMessageListCard.vue?vue&type=style&index=0&id=78eb5104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb5104",
  null
  
)

export default component.exports